<template>
  <validation-provider
    v-slot="{ errors }"
    mode="eager"
    :name="tag.description"
    :rules="tag.custom_settings.validation || ''"
  >
    <v-text-field
      :id="`form-file-editor-${tag.name}`"
      :value="storageFix"
      :label="tag.description"
      outlined
      readonly
      dense
      clearable
      class="fm-text-field"
      :error-messages="errors"
      @click="fmOpen"
      @click:clear="fmReset"
    >
      <template v-slot:append>
        <div class="d-flex">
          <v-icon @click="fmOpen">mdi-text-box-search-outline</v-icon>
          <uploader-button
            :work-dir="workDir"
            class="d-block"
            @upload-success="onFileUpload"
            @upload-error="onUploadError"
          >
            <v-icon>mdi-text-box-plus-outline</v-icon>
          </uploader-button>
        </div>
      </template>
    </v-text-field>
    <file-manager-dialog
      v-model="fmDialog"
      :selected-path="storageFix"
      :work-dir="workDir"
      @fm-select="fmSelect"
      @fm-close="fmClose"
    />
  </validation-provider>
</template>

<script>
import UploaderButton from "@/components/UploaderButton.vue";
import FileManagerDialog from "./FileManagerDialog/FileManagerDialog.vue";

export default {
  components: {
    FileManagerDialog,
    UploaderButton
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    tag: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fmDialog: false
    };
  },
  computed: {
    storageFix() {
      return this.value ? this.value.replace("<STORAGE>", "") : "";
    },
    workDir() {
      if (
        this.tag &&
        this.tag.custom_settings &&
        this.tag.custom_settings.files_dir
      ) {
        return this.tag.custom_settings.files_dir;
      } else {
        return "/files";
      }
    }
  },

  methods: {
    fmOpen() {
      this.fmDialog = true;
    },
    fmClose() {
      this.fmDialog = false;
    },
    fmReset() {
      this.$emit("input", "");
    },
    fmSelect(file) {
      this.fmDialog = false;
      let newValue = file;
      if (!newValue.startsWith("/")) newValue = `/${newValue}`;
      this.$emit("input", `<STORAGE>${newValue}`);
    },
    onFileUpload(files) {
      let newValue = files[0];
      if (!newValue.startsWith("/")) newValue = `/${newValue}`;
      this.$emit("input", `<STORAGE>${newValue}`);
    },
    onUploadError(error) {
      this.$store.commit("addNotice", {
        type: "error",
        message: error
      });
    }
  }
};
</script>
